/**
 * カテゴリメニューのタブ管理
 */
function openCategoryTab(evt, tabName) {
  // カテゴリメニュー内のタブコンテンツのみを対象にする
  const categoryMenu = evt.currentTarget.closest('.header__nav--group-custom');
  const tabcontents = categoryMenu.querySelectorAll('.custom-menu-tabcontent');
  for (let i = 0; i < tabcontents.length; i++) {
    tabcontents[i].style.display = 'none';
  }

  // カテゴリメニュー内のタブリンクのみを対象にする
  const tablinks = categoryMenu.querySelectorAll('.custom-menu-tablinks');
  for (let i = 0; i < tablinks.length; i++) {
    tablinks[i].classList.remove('active');
    tablinks[i].removeAttribute('data-default-open');
  }

  // 選択されたタブコンテンツを表示（カテゴリメニュー内のタブのみを対象）
  const targetTab = categoryMenu.querySelector('#' + tabName + '-tab');
  if (targetTab) {
    targetTab.style.display = 'block';
  }

  // クリックされたタブリンクにアクティブクラスを追加
  evt.currentTarget.classList.add('active');
}

/**
 * ブランドメニューのタブ管理
 */
function openBrandTab(evt, tabName) {
  // ブランドメニュー内のタブコンテンツのみを対象にする
  const brandMenu = evt.currentTarget.closest('.header__nav--group-custom');
  
  // ブランドメニュー内のタブコンテンツのみを対象にする（より具体的なセレクター）
  const tabcontents = brandMenu.querySelectorAll('.custom-menu-tabcontent');
  
  // ブランドメニュー内のタブコンテンツのみを非表示にする
  for (let i = 0; i < tabcontents.length; i++) {
    tabcontents[i].style.display = 'none';
  }

  // ブランドメニュー内のタブリンクのみを対象にする
  const tablinks = brandMenu.querySelectorAll('.custom-menu-tablinks');
  for (let i = 0; i < tablinks.length; i++) {
    tablinks[i].classList.remove('active');
    tablinks[i].removeAttribute('data-default-open');
  }

  // 選択されたタブコンテンツを表示（ブランドメニュー内のタブのみを対象）
  const targetTab = brandMenu.querySelector('#' + tabName + '-tab');
  
  if (targetTab) {
    targetTab.style.display = 'block';
  }

  // クリックされたタブリンクにアクティブクラスを追加
  evt.currentTarget.classList.add('active');
}

// ページ読み込み時にデフォルトタブを開く
document.addEventListener('DOMContentLoaded', function() {
  const defaultTab = document.querySelector('.custom-menu-tablinks[data-default-open]');
  if (defaultTab) {
    defaultTab.click();
  }
});
